import { Injectable, inject } from '@angular/core';
import { LorenAggregate } from '../../../../../../shared/enums/loren-aggregate.enum';
import { LorenAssetService } from '../../../../../loren-assets/services/loren-asset-service/loren-asset.service';
import { LorenAssetTraceService } from '../../../../../loren-traces/services/loren-asset-trace-service/loren-asset-trace.service';
import { DateRange, evaluateDateRange } from "../../../../../../common/forms/period-select/period-select.component";

@Injectable({
    providedIn: 'root',
})
export class LorenAssetReportTypeService {
    private assetService = inject(LorenAssetService);
    private traceService = inject(LorenAssetTraceService);


  getTrackingHistoryForMetering(meteringId: number, period: DateRange) {
    const [from, to] = evaluateDateRange(period)

    return this.traceService.getAssetTraces(meteringId, from, to, 'desc');
  }

  getNumericHistoryForMetering(
    meteringId: number,
    period: DateRange,
    sum = false
  ) {
    const [from, to] = evaluateDateRange(period);
    return this.assetService.getNumericHistory({
      aggregate: LorenAggregate.HOURS,
      from,
      to,
      meteringId,
      sum,
    });
  }

  getBinaryHistoryForMetering(meteringId: number, period: DateRange) {
    const [from, to] = evaluateDateRange(period);
    return this.assetService.getBinaryHistory({ from, to, meteringId, });
  }
}
